import React, { FC } from 'react';
import styled from 'styled-components';

import { Player } from '../../../../../database.schema';
import { MatchPlayer } from './match-player';

const DropWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 20rem;
`;

type TeamDropBoxProps = {
  numberOfSinglesMatches: Array<number>;
  team1Players: Array<Player>;
  team2Players: Array<Player>;
};

export const SinglesDropBoxes: FC<TeamDropBoxProps> = ({ numberOfSinglesMatches, team1Players, team2Players }): JSX.Element => {
  return (
    <div>
      {numberOfSinglesMatches.map((_: number, index: number) => (
        <div key={`result-${index}`}>
          <h3>{`Singles Match ${index + 1}`}</h3>
          <DropWrapper data-testid={`singles-${index}`}>
            <MatchPlayer dndId={`team1Single-${index}`} player={team1Players.length > index ? team1Players[index] : null} team="team1-1" bgColor="red" matchIndex={index} />
            <MatchPlayer dndId={`team2Single-${index}`} player={team2Players.length > index ? team2Players[index] : null} team="team2-1" bgColor="blue" matchIndex={index} />
          </DropWrapper>
        </div>
      ))}
    </div>
  );
};
